export const selectValueForMapping = (mapping) => {
  return {
    identity: mapping.mappable.identity,
    entity_field_id: mapping.entity_field_id,
    type: mapping.mappable_type,
    process_data_field: mapping.process_data_field
  };
};
